import { useTranslation } from "react-i18next";
import ownerPhoto from "@/assets/testimonial-owner.jpg";
import pmPhoto from "@/assets/testimonial-pm.jpg";
import officePhoto from "@/assets/testimonial-office.jpg";
import foremanPhoto from "@/assets/testimonial-foreman.jpg";

const TestimonialsSection = () => {
  const { t } = useTranslation();

  const testimonials = [
    { key: "marco", photo: ownerPhoto },
    { key: "sarah", photo: pmPhoto },
    { key: "liwei", photo: officePhoto },
    { key: "james", photo: foremanPhoto },
  ];

  return (
    <section className="relative bg-background py-24 lg:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative">
        {/* Header */}
        <div className="mb-16 lg:mb-20">
          <div className="flex items-center gap-4 mb-6">
            <div className="h-px flex-1 max-w-[60px] bg-primary" />
            <span className="feature-descriptor text-primary text-xs">
              {t('homeTestimonials.label')}
            </span>
          </div>
          <h2
            className="feature-support-heading max-w-3xl text-4xl font-black leading-[0.95] text-foreground sm:text-5xl lg:text-6xl"
            style={{ fontFamily: "'Impact', 'Arial Black', sans-serif" }}
          >
            {t('homeTestimonials.title')}{" "}
            <br className="feature-testimonials-break" />
            <span className="text-[#4A7BF7]">{t('homeTestimonials.titleHighlight')}</span> {t('homeTestimonials.titleEnd')}
          </h2>
        </div>

        {/* Testimonial Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {testimonials.map((item) => (
            <div
              key={item.key}
              className="bg-card border border-border rounded-xl p-6 flex flex-col transition-all duration-300 hover:border-primary/30"
            >
              <p className="text-foreground/80 text-[15px] leading-relaxed mb-6 flex-1">
                "{t(`homeTestimonials.items.${item.key}.quote`)}"
              </p>
              <div className="flex items-center gap-3 mt-auto">
                <img
                  src={item.photo}
                  alt={t(`homeTestimonials.items.${item.key}.name`)}
                  loading="lazy"
                  width={512}
                  height={512}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                />
                <div className="min-w-0">
                  <p className="text-foreground font-bold text-sm truncate">{t(`homeTestimonials.items.${item.key}.name`)}</p>
                  <p className="text-[#4A7BF7] text-xs truncate">{t(`homeTestimonials.items.${item.key}.role`)}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
